var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.707 15.293-12-12a1 1 0 0 0-1.414 0l-12 12A1 1 0 0 0 6 17h3v12.708A3.3 3.3 0 0 0 12.292 33h11.416A3.3 3.3 0 0 0 27 29.708V17h3a1 1 0 0 0 .707-1.707ZM26 15a1 1 0 0 0-1 1v13.708A1.294 1.294 0 0 1 23.708 31H12.292A1.294 1.294 0 0 1 11 29.708V16a1 1 0 0 0-1-1H8.414L18 5.414 27.586 15Z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14v.728A3.138 3.138 0 0 0 17.143 21h1.714a1.143 1.143 0 0 1 0 2.286h-3a1 1 0 0 0 0 2H17V26a1 1 0 0 0 2 0v-.728A3.138 3.138 0 0 0 18.857 19h-1.714a1.143 1.143 0 0 1 0-2.286h3a1 1 0 0 0 0-2H19V14a1 1 0 0 0-2 0Z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUp);
export default __webpack_public_path__ + "static/media/price-up.99cddeb1f69797e9499e0baaa1bc2b63.svg";
export { ForwardRef as ReactComponent };